/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageNew_lists$ref: FragmentReference;
declare export opaque type MessageNew_lists$fragmentType: MessageNew_lists$ref;
export type MessageNew_lists = {|
  +id: string,
  +$refType: MessageNew_lists$ref,
|};
export type MessageNew_lists$data = MessageNew_lists;
export type MessageNew_lists$key = {
  +$data?: MessageNew_lists$data,
  +$fragmentRefs: MessageNew_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageNew_lists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '2866810fbed6b0089504ab03ef7923e1';

module.exports = node;
